import EventBus from '../services/event-bus';
import { EVENTS } from '../services/constants';

angular.module('eatself').classy.controller({
	name: 'StructuredDataController',
	inject: ['ShopService', '$stateParams', '$scope', '$state', '$sce','ADMIN','UrlService'],
	init() {
		EventBus.$on(EVENTS.shopChanged, (shop) => {
			this.shop = shop;
			this.updateProduct();
			this.regenerateData();
		})
		this.$scope.$on('$stateChangeSuccess', () => {
			if (this.$stateParams.tid && this.shop) {
				this.updateProduct();
			} else {
				this.product = null;
			}
			this.regenerateData();
		});
	},
	methods: {
		updateProduct() {
			if (this.$stateParams.tid) {
				let item = this.ShopService.getItem(this.$stateParams.tid, this.shop.productTree);
				this.product = item.product;
			} else {
				this.product = null;
			}
		},
		regenerateData() {
			if (this.shop) {
				let canonicalDomain = null;
				if (this.shop.CanonicalDomain) {
					canonicalDomain = this.shop.CanonicalDomain;
				} else if (this.shop.Subdomain)  {
					canonicalDomain = this.shop.Subdomain+'.eatself.com';
				}
				if (canonicalDomain) {
					this.shopUrl = `https://${canonicalDomain}`;
					this.canonicalUrl = `https://${canonicalDomain}${location.pathname}${location.search}`;
				} else {
					this.shopUrl = `https://app.eatself.com/${this.shop.ShopId}`;
					this.canonicalUrl = null;
				}
				let hours = this.ShopService.getMergedOpenHours(this.shop)[0];
				let flatHours = [];
				let dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
				for (let i in hours) {
					for (let j in hours[i]) {
						flatHours.push({
							dayOfWeek: dayNames[i],
							opens: hours[i][j].open_hour.format('HH:mm'),
							closes: hours[i][j].close_hour.format('HH:mm'),
						});
					}
				}
				this.shopOpeningHours = flatHours;
				this.shopDeliveryEnabled = this.ShopService.isAreaEnabled(this.shop, this.ShopService.SALE_AREAS.DELIVERY);
				this.shopPickupEnabled = this.ShopService.isAreaEnabled(this.shop, this.ShopService.SALE_AREAS.TO_GO);
			}
			this.shopData = this.shop && {
				"@context": 'http://schema.org',
				"@type": this.shop.info.BusinessType || 'Restaurant',
				"@id": `https://app.eatself.com/${this.shop.ShopId}`,
				acceptsReservations: false,
				address: {
					"@type": "PostalAddress",
					addressCountry: this.shop.Country,
					addressLocality: this.shop.City,
					addressRegion: null,
					postalCode: this.shop.Zip,
					streetAddress: `${this.shop.Address1} ${this.shop.Address2}`,
				},
				description: this.shop.DefaultDescription,
				disambiguatingDescription: this.shop.description,
				department: [],
				geo: {
					"@type": 'GeoCoordinates',
					latitude: this.shop.Location.latitude,
					longitude: this.shop.Location.longitude,
				},
				menu: this.shopUrl + '/accueil',
				name: this.shop.DefaultName,
				openingHoursSpecification: _.map(this.shopOpeningHours, (hours) => ({
					"@type": 'OpeningHoursSpecification',
					dayOfWeek: hours.dayOfWeek,
					opens: hours.opens,
					closes: hours.closes,
					validFrom: null,
					validThrough: null,
				})),
				potentialAction: {
					"@type": 'OrderAction',
					target: {
						"@type": 'EntryPoint',
						inLanguage: 'fr-FR',
						actionPlatform: 'http://schema.org/DesktopWebPlatform',
						url: this.shopUrl + '/carte',
					},
					deliveryMethod: _.filter([
						this.shopDeliveryEnabled && 'http://purl.org/goodrelations/v1#DeliveryModeOwnFleet',
						this.shopPickupEnabled && 'http://purl.org/goodrelations/v1#DeliveryModePickUp'
					], (method) => method),
					priceSpecification: this.shopDeliveryEnabled && {
						"@type": "DeliveryChargeSpecification",
						appliesToDeliveryMethod: "http://purl.org/goodrelations/v1#DeliveryModeOwnFleet",
						priceCurrency: this.shop.CurrencyCode,
						price: 0,
						eligibleTransactionVolume: {
							"@type": "PriceSpecification",
							priceCurrency: this.shop.CurrencyCode,
							price: this.shop.MinDeliveryAmount,
						}
					}
				},
				telephone: this.shop.Tel,
				url: this.shopUrl,
				// Restaurant properties
				image: [
					`https:${ this.UrlService.imagePath(this.shop.ShopId, this.shop.Image) }`,
				],
				servesCuisine: this.shop.info.ServesCuisine,
			};
			let treeItem = this.ShopService.getItem(this.$stateParams.tid,this.ShopService.shop?.productTree);
			this.productData = this.product && {
				"@context": 'http://schema.org',
				"@type": 'Product',
				name: this.product.dn,
				image: 'https:' + this.UrlService.imagePath(this.product.ShopId, this.product.ims),
				description: this.product.dd,
				brand: {
					"@type": 'Brand',
					name: treeItem?.parent?.product?.dn,
				},
				review: null,
				aggregateRating: null,
				offers: {
					"@type": 'Offer',
					price: this.product.dp,
					priceCurrency: this.shop.CurrencyCode,
					priceValidUntil: null,
					availability: this.product.av ? "http://schema.org/InStock" : "http://schema.org/OutOfStock",
				},
				url: location.href,
			};

			this.ldJson = this.$sce.trustAsJs(JSON.stringify(_.compact([this.shopData, this.productData]), null, "\t"));
		},
	}
})
